import { render, staticRenderFns } from "./MyInforcedProposals.vue?vue&type=template&id=0383ffbe&scoped=true&"
import script from "./MyInforcedProposals.vue?vue&type=script&lang=js&"
export * from "./MyInforcedProposals.vue?vue&type=script&lang=js&"
import style0 from "./MyInforcedProposals.vue?vue&type=style&index=0&id=0383ffbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0383ffbe",
  null
  
)

component.options.__file = "MyInforcedProposals.vue"
export default component.exports